module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("XDo45"))).then(() => parcelRequire('hEqeo'));